/* eslint-disable import/no-extraneous-dependencies */
import { ActionType, createAction } from 'typesafe-actions';
import { FormState } from './formReducer';

export enum FormActionTypes {
  Updated = '[Form] Updated',
  Validated = '[Form] Validated',
  Loading = '[Form] Loading',
  Loaded = '[Form] Loaded',
  Submited = '[Form] Submited',
  LoadSuccess = '[Form] Success',
  LoadFailure = '[Form] Failure',
  InvalidRemID = '[Form] InvalidRemID',
  ValidRemID = '[Form] ValidRemID',
}

export const formActions = {
  updated: createAction(FormActionTypes.Updated)(),
  validated: createAction(FormActionTypes.Validated)(),
  submited: createAction(FormActionTypes.Submited)<FormState>(),
  loading: createAction(FormActionTypes.Loading)(),
  loaded: createAction(FormActionTypes.Loaded)(),
  inValidRemId: createAction(FormActionTypes.InvalidRemID)(),
  validRemId: createAction(FormActionTypes.ValidRemID)(),
  success: createAction(FormActionTypes.LoadSuccess)(),
  failure: createAction(FormActionTypes.LoadFailure)(),
};

export type FormAction = ActionType<typeof formActions>;
